import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiV1 } from "api-v2";
import { useCurrentCompanyId } from "hooks/auth";
import type { UserListItem } from "../../../types/userInvite";

const reactivateUser = async (userId: number): Promise<UserListItem> => {
  const response = await apiV1.post<UserListItem>(`users/${userId}/reactivate`);
  return response.data;
};

export const useReactivateUserMutation = () => {
  const queryClient = useQueryClient();
  const companyId = useCurrentCompanyId();

  return useMutation<UserListItem, Error, number>({
    mutationFn: reactivateUser,
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users", companyId] });
    },
  });
};
